export default "__VITE_ASSET__DxOgkg0E__"